export default "/images/topdanmark-min-org.avif?40f6309ef5af833e2601e3f6323e8aeb";